export * from './types'
export * from './ModalSecondaryLayer'

import Modal from './Modal'
import ModalHeader from './ModalHeader'
import { ModalBody } from './ModalBody'
import withModal from './withModal'

export {
    Modal,
    ModalHeader,
    ModalBody,
    withModal
}
